// extracted by mini-css-extract-plugin
export default {"container":"Zm7mt","row":"d96Fq","text":"tXGHD","load":"AL5KD","price":"BXox6","title-row":"WGdw3","titleRow":"WGdw3"};